import { useId, type ReactNode } from "react"
import { Info } from "lucide-react"
import { Tooltip } from "../ui/tooltip"

/** Focus and touch reveal the same definitions as hover. Screen readers get a description. */
export function NutritionHelp({ label, children }: { label: string; children: ReactNode }) {
  const descriptionId = useId()
  return (
    <Tooltip content={children}>
      <button
        type="button"
        className="inline-flex size-5 items-center justify-center rounded-full align-middle text-muted-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring max-sm:size-11"
        aria-label={label}
        aria-describedby={descriptionId}
      >
        <Info className="size-3.5" aria-hidden="true" />
      </button>

      <span id={descriptionId} className="sr-only">
        {children}
      </span>
    </Tooltip>
  )
}
